// MyProfile.js
import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";

const ExtendedProfile = ({ userId }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [userTitle, setUserTitle] = useState('');

  useEffect(() => {
    // Fetch user profile data based on userId
    // You might need to make an API call to your backend
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = async (userId) => {
    // Example API call to fetch user profile data
    try {
      const response = await fetch(`/api/userprofiles/${userId}`);
      const userData = await response.json();

      setName(userData.name);
      setEmail(userData.email);
      setMobileNumber(userData.mobileNumber);
      setUserTitle(userData.userTitle);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  const handleProfileUpdate = () => {
    const updatedProfileData = {
      name,
      email,
      mobileNumber,
      userTitle,
    };

    // Make an API call to update the user profile
    fetch(`/api/userprofiles/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedProfileData),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log('Profile updated successfully:', data);
      })
      .catch((error) => {
        console.error('Error updating profile:', error);
      });
  };

  const handleCancel = () => {
    // The form fields or navigate to another page
  };

  return (
    <MainLayout>
    <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Extended Profile</h2>
      </div>
    <div className='profile-container  text-white'>
      
      <div className='profile-form'>
        <label>Name:</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

        <label>Email:</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label>Mobile Number:</label>
        <input type="tel" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />

        <label>User Title:</label>
        <input type="title" value={userTitle} onChange={(e) => setUserTitle(e.target.value)} />

        <div className='button-container'>
          <button className='update-button' onClick={handleProfileUpdate}>Update Profile</button>
          <button className='cancel-button' onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </div>
    </MainLayout>
  );
};

export default ExtendedProfile;

